import styled from 'styled-components';

export const PremiumButtonWrapper = styled.div`
  display: inline-flex;

  .ant-btn {
    border-radius: 10px !important;
    font-weight: 600 !important;
    padding: 6px 20px !important;
    height: auto !important;
    font-size: 13px !important;
  }
`;

export const BulkEmbedContainerStyled = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ToolbarRowStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 24px;
  border-bottom: 1px solid ${({ theme }) => theme?.colors?.borderLight ?? '#E5E7EB'};
  gap: 6px;
  flex-shrink: 0;
  background: ${({ theme }) => theme?.colors?.white ?? '#ffffff'};
`;

export const ToolbarActionsStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const RowListStyled = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: ${({ theme }) => theme?.colors?.backgroundLight ?? '#F3F4F6'};
`;

export const RowCardStyled = styled.div`
  flex-shrink: 0;
  border: 1px solid ${({ $highlighted, $invalid, theme }) =>
    $invalid
      ? (theme?.colors?.warningBorder ?? '#FFB020')
      : $highlighted
      ? (theme?.colors?.warningBorder ?? '#FFB020')
      : (theme?.colors?.borderLight ?? '#E5E7EB')};
  border-radius: 8px;
  background: ${({ $highlighted, $invalid, theme }) =>
    $invalid
      ? (theme?.colors?.warningBg ?? '#FFFBEB')
      : $highlighted
      ? (theme?.colors?.warningBg ?? '#FFFAF1')
      : (theme?.colors?.white ?? '#ffffff')};
  overflow: hidden;
  box-shadow: ${({ $highlighted, $invalid, theme }) =>
    $invalid
      ? `0 0 0 2px ${theme?.colors?.warningBorder ?? '#FFB020'}40`
      : $highlighted
      ? `0 0 0 2px ${theme?.colors?.warningBorder ?? '#FFB020'}40`
      : '0 1px 4px rgba(0,0,0,0.07)'};
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
`;

export const RowHintStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.warningMessage ?? '#996A13'};
  flex: 1;
`;

export const RowCardHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: ${({ theme }) => theme?.colors?.backgroundLight ?? '#F9FAFB'};
  border-bottom: ${({ $collapsed, theme }) => $collapsed ? 'none' : `1px solid ${theme?.colors?.borderLight ?? '#E5E7EB'}`};
`;

export const RowCardHeaderLeftStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  user-select: none;
`;

export const RowCardSummaryStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const SummaryItemStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  min-width: 0;
  flex-shrink: 0;
`;

export const SummaryLabelStyled = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.textSecondary ?? '#9CA3AF'};
  white-space: nowrap;
  flex-shrink: 0;
`;

export const SummaryValueStyled = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111827'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
`;

export const SummaryPipeStyled = styled.span`
  color: ${({ theme }) => theme?.colors?.borderLight ?? '#D1D5DB'};
  font-size: 16px;
  font-weight: 300;
  flex-shrink: 0;
  line-height: 1;
`;

export const RowCardHeaderRightStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
`;

export const RowCardBodyStyled = styled.div`
  padding: 16px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const FieldsRowStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const FieldItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
`;

export const FieldLabelStyled = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme?.colors?.textSecondary ?? '#6B7280'};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RequiredMark = styled.span`
  color: ${({ theme }) => theme?.colors?.error ?? '#DC2626'};
  margin-left: 2px;
`;

export const RowMissingBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.warningMessage ?? '#996A13'};
  background: ${({ theme }) => theme?.colors?.warningBg ?? '#FFFBEB'};
  border: 1px solid ${({ theme }) => theme?.colors?.warningBorder ?? '#FFB020'};
  border-radius: 4px;
  padding: 1px 6px;
  white-space: nowrap;
`;

export const SubmitHintText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme?.colors?.warningMessage ?? '#996A13'};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const FieldValueStyled = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111827'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 1px 0;
`;

export const FieldValueReadOnlyStyled = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111827'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${({ theme }) => theme?.colors?.backgroundLight ?? '#F3F4F6'};
  border: 1px solid ${({ theme }) => theme?.colors?.borderLight ?? '#E5E7EB'};
  border-radius: 4px;
  padding: 2px 8px;
  height: 24px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

export const EmptyStateStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: ${({ theme }) => theme?.colors?.textSecondary ?? '#6B7280'};
  font-size: 14px;
`;

export const CardSectionDividerStyled = styled.div`
  width: 1px;
  height: 20px;
  background: ${({ theme }) => theme?.colors?.borderLight ?? '#E5E7EB'};
  flex-shrink: 0;
  margin: 0 6px;
`;

export const FileUploadGroupStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const FilePillStyled = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${({ $status }) => $status === 'invalid' ? '#F87171' : '#34D399'};
  background: ${({ $status }) => $status === 'invalid' ? '#FEF2F2' : '#F0FDF4'};
  color: ${({ $status }) => $status === 'invalid' ? '#B91C1C' : '#065F46'};
  font-size: 12px;
  cursor: ${({ $status }) => $status === 'invalid' ? 'default' : 'pointer'};
  width: fit-content;
  max-width: 160px;
  line-height: 1.4;
  outline: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RoleContextGroupStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const RoleContextFieldStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;

export const RoleContextValueBoxStyled = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 7px;
  border: 1px solid ${({ theme }) => theme?.colors?.borderLight ?? '#E5E7EB'};
  border-radius: 6px;
  background: ${({ theme }) => theme?.colors?.white ?? '#ffffff'};
  box-sizing: border-box;
`;

export const SubmitRowStyled = styled.div`
  padding: 12px 24px;
  border-top: 1px solid ${({ theme }) => theme?.colors?.borderLight ?? '#E5E7EB'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: ${({ theme }) => theme?.colors?.white ?? '#ffffff'};
`;

export const StepBarStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 44px;
  padding: 0 24px;
  border-bottom: 1px solid ${({ theme }) => theme?.colors?.borderLight ?? '#E5E7EB'};
  background: ${({ theme }) => theme?.colors?.white ?? '#ffffff'};
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const StepBarLeftStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;

export const StepBarRightStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  visibility: ${({ $hidden }) => $hidden ? 'hidden' : 'visible'};
  pointer-events: ${({ $hidden }) => $hidden ? 'none' : 'auto'};
`;

export const StepClickableGroupStyled = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  border-radius: 6px;
  padding: 2px 4px;
  transition: background 0.15s;

  &:hover {
    background: ${({ theme }) => theme?.colors?.backgroundLight ?? '#F3F4F6'};
  }
`;

export const StepBadgeStyled = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  background: ${({ $active, theme }) =>
    $active ? (theme?.colors?.primary ?? '#008080') : (theme?.colors?.borderLight ?? '#E5E7EB')};
  color: ${({ $active, theme }) =>
    $active ? (theme?.colors?.white ?? '#ffffff') : (theme?.colors?.textSecondary ?? '#9CA3AF')};
`;

export const StepLabelStyled = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active, theme }) =>
    $active ? (theme?.colors?.textPrimary ?? '#111827') : (theme?.colors?.textSecondary ?? '#9CA3AF')};
`;

export const StepDividerStyled = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme?.colors?.borderLight ?? '#D1D5DB'};
  flex-shrink: 0;
`;

export const StepHintStyled = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme?.colors?.textSecondary ?? '#6B7280'};
  margin-left: 4px;
`;
